import { createApiCallActions } from 'src/app/common/store/generic.actions';
import {
  HealthInsuranceLeadModel,
  CarInsuranceLeadModel,
  HouseInsuranceLeadModel,
  LeadDetailModel,
  HealthLeadFormModel,
  CarLeadFormModel,
  HouseLeadFormModel,
  BaseLeadFormModel,
  LeadStatusFlow,
  LeadPrincipalCandidateListItemModel,
} from './types';
import { Action } from '../view/types';
import { ListItem, ReferencesItem } from '../typeahead/types';

export const leadActions = {
  getByUniqueId: createApiCallActions<LeadDetailModel>('lead', 'getByUniqueId'),
  getHealthDetail: createApiCallActions<HealthInsuranceLeadModel>(
    'lead',
    'getHealthDetail',
  ),
  getCarDetail: createApiCallActions<CarInsuranceLeadModel>(
    'lead',
    'getCarDetail',
  ),
  getHouseDetail: createApiCallActions<HouseInsuranceLeadModel>(
    'lead',
    'getHouseDetail',
  ),
  sendLead: createApiCallActions<any>('lead', 'sendLead'),
  updateLeadDetail: createApiCallActions<string>('lead', 'updateLeadDetail'),
  updateHealthDetail: createApiCallActions<string>(
    'lead',
    'updateHealthDetail',
  ),
  updateCarDetail: createApiCallActions<string>('lead', 'updateCarDetail'),
  updateHouseDetail: createApiCallActions<string>('lead', 'updateHouseDetail'),
  createLead: createApiCallActions<any>('lead', 'createLead'),
  createHealthLead: createApiCallActions<any>('lead', 'createHealthLead'),
  createCarLead: createApiCallActions<any>('lead', 'createCarLead'),
  createHouseLead: createApiCallActions<any>('lead', 'createHouseLead'),
  delete: createApiCallActions<boolean>('lead', 'delete'),

  getBaseLeadModel: createApiCallActions<BaseLeadFormModel>(
    'lead',
    'getBaseLeadModel',
  ),
  getHealthLeadModel: createApiCallActions<HealthLeadFormModel>(
    'lead',
    'getHealthLeadModel',
  ),
  getCarLeadModel: createApiCallActions<CarLeadFormModel>(
    'lead',
    'getCarLeadModel',
  ),
  getHouseLeadModel: createApiCallActions<HouseLeadFormModel>(
    'lead',
    'getHouseLeadModel',
  ),
  getStatusFlow: createApiCallActions<LeadStatusFlow[]>(
    'lead',
    'getStatusFlow',
  ),
  getStatusActions: createApiCallActions<Action[]>('lead', 'getStatusActions'),
  qualify: createApiCallActions<LeadDetailModel>('lead', 'qualify'),
  markAsWon: createApiCallActions<LeadDetailModel>('lead', 'markAsWon'),
  markAsLost: createApiCallActions<LeadDetailModel>('lead', 'markAsLost'),
  createContractRequest: createApiCallActions<LeadDetailModel>(
    'lead',
    'createContractRequest',
  ),
  reactivate: createApiCallActions<LeadDetailModel>('lead', 'reactivate'),
  getPrincipalCandidates: createApiCallActions<
    LeadPrincipalCandidateListItemModel[]
  >('lead', 'getPrincipalCandidates'),
  setAsPrincipal: createApiCallActions<boolean>('lead', 'setAsPrincipal'),
  markAsNotDuplicate: createApiCallActions<boolean>(
    'lead',
    'markAsNotDuplicate',
  ),
  markAsDuplicate: createApiCallActions<boolean>('lead', 'markAsDuplicate'),
};
export type LeadAction = typeof leadActions;
